// Generated by ReScript, PLEASE EDIT WITH CARE
/* @generated */
'use strict';

var Caml_option = require("rescript/lib/js/caml_option.js");
var ReactRelay = require("react-relay");
var RescriptRelay = require("rescript-relay/src/RescriptRelay.bs.js");

function makeRefetchVariables() {
  
}

var Types = {
  makeRefetchVariables: makeRefetchVariables
};

var variablesConverter = {};

function convertVariables(v) {
  return RescriptRelay.convertObj(v, variablesConverter, undefined, undefined);
}

var wrapResponseConverter = {"__root":{"sessionV5_authenticatedUserV2_value":{"f":""}}};

function convertWrapResponse(v) {
  return RescriptRelay.convertObj(v, wrapResponseConverter, undefined, null);
}

var responseConverter = {"__root":{"sessionV5_authenticatedUserV2_value":{"f":""}}};

function convertResponse(v) {
  return RescriptRelay.convertObj(v, responseConverter, undefined, undefined);
}

var Internal = {
  variablesConverter: variablesConverter,
  variablesConverterMap: undefined,
  convertVariables: convertVariables,
  wrapResponseConverter: wrapResponseConverter,
  wrapResponseConverterMap: undefined,
  convertWrapResponse: convertWrapResponse,
  responseConverter: responseConverter,
  responseConverterMap: undefined,
  convertResponse: convertResponse,
  convertWrapRawResponse: convertWrapResponse,
  convertRawResponse: convertResponse
};

var Utils = {};

var node = ((function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "firstName",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "lastName",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "displayName",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "emailAddress",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "concreteType": "ProfilePhoto",
  "kind": "LinkedField",
  "name": "profilePhoto",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "key",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "nodeId",
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "brokerage",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "UserSessionDataQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "SessionV5",
        "kind": "LinkedField",
        "name": "sessionV5",
        "plural": false,
        "selections": [
          {
            "kind": "CatchField",
            "field": {
              "alias": null,
              "args": null,
              "concreteType": null,
              "kind": "LinkedField",
              "name": "authenticatedUserV2",
              "plural": false,
              "selections": [
                (v0/*: any*/),
                {
                  "args": null,
                  "kind": "FragmentSpread",
                  "name": "UserSessionUserDisplayInfo_userDisplayInfo"
                },
                {
                  "kind": "InlineFragment",
                  "selections": [
                    {
                      "args": null,
                      "kind": "FragmentSpread",
                      "name": "UserSessionChapterPreferences_chapterPreferences"
                    },
                    {
                      "args": null,
                      "kind": "FragmentSpread",
                      "name": "UserSessionChapterTimezone_chapterTimezone"
                    },
                    {
                      "args": null,
                      "kind": "FragmentSpread",
                      "name": "UserSessionChapterInfo_chapterInfo"
                    },
                    {
                      "args": null,
                      "kind": "FragmentSpread",
                      "name": "UserSessionAgentInfo_agent"
                    },
                    {
                      "args": null,
                      "kind": "FragmentSpread",
                      "name": "UserSessionPlanFeatures_planFeatures"
                    },
                    {
                      "args": null,
                      "kind": "FragmentSpread",
                      "name": "UserSessionPermissions_permissions"
                    }
                  ],
                  "type": "Agent",
                  "abstractKey": null
                },
                {
                  "kind": "InlineFragment",
                  "selections": [
                    {
                      "args": null,
                      "kind": "FragmentSpread",
                      "name": "UserSessionClientInfo_clientInfo"
                    },
                    {
                      "args": null,
                      "kind": "FragmentSpread",
                      "name": "UserSessionClientAgent_agent"
                    }
                  ],
                  "type": "RegisteredClient",
                  "abstractKey": null
                }
              ],
              "storageKey": null
            },
            "to": "RESULT"
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "UserSessionDataQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "SessionV5",
        "kind": "LinkedField",
        "name": "sessionV5",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": null,
            "kind": "LinkedField",
            "name": "authenticatedUserV2",
            "plural": false,
            "selections": [
              (v0/*: any*/),
              {
                "kind": "TypeDiscriminator",
                "abstractKey": "__isAuthenticatedUserV6"
              },
              {
                "kind": "InlineFragment",
                "selections": [
                  (v1/*: any*/),
                  (v2/*: any*/),
                  (v3/*: any*/),
                  (v4/*: any*/),
                  (v5/*: any*/),
                  (v6/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "ChapterV5",
                    "kind": "LinkedField",
                    "name": "defaultChapter",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "ChapterPreferencesV5",
                        "kind": "LinkedField",
                        "name": "preferences",
                        "plural": false,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "granularNotificationSettings",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "improvedLocations",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "mlsComingSoon",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "payingChapter",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "anonymousMatching",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "hideChapterStats",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "defaultToChapterPreferenceAreas",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "mlsPropertyStatusCheck",
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      },
                      (v7/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "timezone",
                        "storageKey": null
                      },
                      {
                        "alias": "id",
                        "args": null,
                        "kind": "ScalarField",
                        "name": "databaseId",
                        "storageKey": null
                      },
                      (v4/*: any*/)
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "tanStaff",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "permissions",
                    "storageKey": null
                  },
                  (v8/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "AccountMember",
                    "kind": "LinkedField",
                    "name": "membership",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "role",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "AccountV5",
                        "kind": "LinkedField",
                        "name": "account",
                        "plural": false,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "accountStatus",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "AccountMember",
                            "kind": "LinkedField",
                            "name": "owner",
                            "plural": false,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "Agent",
                                "kind": "LinkedField",
                                "name": "agent",
                                "plural": false,
                                "selections": [
                                  (v1/*: any*/),
                                  (v2/*: any*/),
                                  (v3/*: any*/),
                                  (v4/*: any*/),
                                  (v7/*: any*/)
                                ],
                                "storageKey": null
                              },
                              (v7/*: any*/)
                            ],
                            "storageKey": null
                          },
                          (v7/*: any*/),
                          {
                            "alias": "subscription_",
                            "args": null,
                            "concreteType": "AccountSubscriptionV5",
                            "kind": "LinkedField",
                            "name": "subscription",
                            "plural": false,
                            "selections": [
                              (v1/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "SubscriptionPlanV5",
                                "kind": "LinkedField",
                                "name": "plan",
                                "plural": false,
                                "selections": [
                                  (v1/*: any*/),
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "features",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": "type_",
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "type",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "handle",
                                    "storageKey": null
                                  }
                                ],
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      },
                      (v7/*: any*/)
                    ],
                    "storageKey": null
                  }
                ],
                "type": "Agent",
                "abstractKey": null
              },
              {
                "kind": "InlineFragment",
                "selections": [
                  (v1/*: any*/),
                  (v2/*: any*/),
                  (v3/*: any*/),
                  (v4/*: any*/),
                  (v5/*: any*/),
                  (v6/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "status",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Agent",
                    "kind": "LinkedField",
                    "name": "agent",
                    "plural": false,
                    "selections": [
                      (v1/*: any*/),
                      (v7/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "membershipStatus",
                        "storageKey": null
                      },
                      (v8/*: any*/),
                      (v4/*: any*/),
                      (v6/*: any*/),
                      (v5/*: any*/)
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "CapAgentBuyerNeed",
                    "kind": "LinkedField",
                    "name": "agentBuyerNeed",
                    "plural": false,
                    "selections": [
                      (v1/*: any*/)
                    ],
                    "storageKey": null
                  }
                ],
                "type": "RegisteredClient",
                "abstractKey": null
              },
              {
                "kind": "InlineFragment",
                "selections": [
                  (v7/*: any*/)
                ],
                "type": "Node",
                "abstractKey": "__isNode"
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "ed4052bb7b77372455cb136b2b6fd4e6",
    "id": null,
    "metadata": {},
    "name": "UserSessionDataQuery",
    "operationKind": "query",
    "text": "query UserSessionDataQuery {\n  sessionV5 {\n    authenticatedUserV2 {\n      __typename\n      ...UserSessionUserDisplayInfo_userDisplayInfo\n      ... on Agent {\n        ...UserSessionChapterPreferences_chapterPreferences\n        ...UserSessionChapterTimezone_chapterTimezone\n        ...UserSessionChapterInfo_chapterInfo\n        ...UserSessionAgentInfo_agent\n        ...UserSessionPlanFeatures_planFeatures\n        ...UserSessionPermissions_permissions\n      }\n      ... on RegisteredClient {\n        ...UserSessionClientInfo_clientInfo\n        ...UserSessionClientAgent_agent\n      }\n      ... on Node {\n        __isNode: __typename\n        __typename\n        nodeId\n      }\n    }\n  }\n}\n\nfragment UserComponentsAgentInfoBlock_agent on Agent {\n  id\n  membershipStatus\n  brokerage\n  displayName\n  profilePhoto {\n    key\n  }\n}\n\nfragment UserSessionAgentInfo_agent on Agent {\n  id\n  tanStaff\n  permissions\n  firstName\n  lastName\n  displayName\n  brokerage\n  emailAddress\n  profilePhoto {\n    key\n  }\n  membership {\n    role\n    account {\n      accountStatus\n      owner {\n        agent {\n          id\n          firstName\n          lastName\n          displayName\n          nodeId\n        }\n        nodeId\n      }\n      nodeId\n    }\n    nodeId\n  }\n}\n\nfragment UserSessionChapterInfo_chapterInfo on Agent {\n  defaultChapter {\n    id: databaseId\n    displayName\n    nodeId\n  }\n}\n\nfragment UserSessionChapterPreferences_chapterPreferences on Agent {\n  defaultChapter {\n    preferences {\n      granularNotificationSettings\n      improvedLocations\n      mlsComingSoon\n      payingChapter\n      anonymousMatching\n      hideChapterStats\n      defaultToChapterPreferenceAreas\n      mlsPropertyStatusCheck\n    }\n    nodeId\n  }\n}\n\nfragment UserSessionChapterTimezone_chapterTimezone on Agent {\n  defaultChapter {\n    timezone\n    nodeId\n  }\n}\n\nfragment UserSessionClientAgent_agent on RegisteredClient {\n  agent {\n    ...UserComponentsAgentInfoBlock_agent\n    id\n    displayName\n    emailAddress\n    profilePhoto {\n      key\n    }\n    nodeId\n  }\n}\n\nfragment UserSessionClientInfo_clientInfo on RegisteredClient {\n  id\n  firstName\n  lastName\n  displayName\n  status\n  emailAddress\n  profilePhoto {\n    key\n  }\n  agent {\n    id\n    nodeId\n  }\n  agentBuyerNeed {\n    id\n  }\n}\n\nfragment UserSessionPermissions_permissions on Agent {\n  permissions\n}\n\nfragment UserSessionPlanFeatures_planFeatures on Agent {\n  membership {\n    account {\n      subscription_: subscription {\n        id\n        plan {\n          ...UserSessionPlansFeatures_plan\n        }\n      }\n      nodeId\n    }\n    nodeId\n  }\n}\n\nfragment UserSessionPlansFeatures_plan on SubscriptionPlanV5 {\n  id\n  features\n  type_: type\n  handle\n}\n\nfragment UserSessionUserDisplayInfo_userDisplayInfo on AuthenticatedUserV6 {\n  __isAuthenticatedUserV6: __typename\n  __typename\n  ... on Agent {\n    id\n    firstName\n    lastName\n    displayName\n    emailAddress\n    profilePhoto {\n      key\n    }\n  }\n  ... on RegisteredClient {\n    id\n    firstName\n    lastName\n    displayName\n    emailAddress\n    profilePhoto {\n      key\n    }\n  }\n}\n"
  }
};
})());

function load(environment, variables, fetchPolicy, fetchKey, networkCacheConfig) {
  return ReactRelay.loadQuery(environment, node, convertVariables(variables), {
              fetchKey: fetchKey,
              fetchPolicy: fetchPolicy,
              networkCacheConfig: networkCacheConfig
            });
}

function queryRefToObservable(token) {
  return Caml_option.nullable_to_opt(token.source);
}

function queryRefToPromise(token) {
  return new Promise((function (resolve, param) {
                var o = queryRefToObservable(token);
                if (o !== undefined) {
                  Caml_option.valFromOption(o).subscribe({
                        complete: (function () {
                            resolve({
                                  TAG: "Ok",
                                  _0: undefined
                                });
                          })
                      });
                  return ;
                } else {
                  return resolve({
                              TAG: "Error",
                              _0: undefined
                            });
                }
              }));
}

exports.Types = Types;
exports.Internal = Internal;
exports.Utils = Utils;
exports.node = node;
exports.load = load;
exports.queryRefToObservable = queryRefToObservable;
exports.queryRefToPromise = queryRefToPromise;
/* node Not a pure module */
